import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { FiLock, FiGithub } from 'react-icons/fi';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="border-t border-borderDark bg-bgDark pt-12 pb-8 mt-auto">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8">
          <div className="flex flex-col items-center md:items-start gap-3">
            <div className="flex items-center gap-2 text-textMuted">
              <SafeIcon icon={FiLock} className="text-lg" />
              <span className="text-sm font-medium">&copy; {currentYear}</span>
              <a 
                href="https://github.com/ecomcodeLab" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-1.5 text-primary hover:text-primaryHover transition-colors font-bold"
              >
                <SafeIcon icon={FiGithub} className="text-sm" />
                ecomcodelab
              </a>
            </div>
            <div className="flex items-center gap-3">
              <span className="px-2 py-0.5 rounded text-[10px] bg-success/10 text-success border border-success/20 uppercase font-bold tracking-wider">
                Cookieless
              </span>
              <span className="px-2 py-0.5 rounded text-[10px] bg-primary/10 text-primary border border-primary/20 uppercase font-bold tracking-wider">
                Private
              </span>
            </div>
          </div>
          
          <div className="flex flex-wrap justify-center gap-6 text-sm">
            <Link to="/impressum" className="text-textMuted hover:text-primary transition-colors">
              Impressum
            </Link>
            <Link to="/datenschutz" className="text-textMuted hover:text-primary transition-colors">
              Datenschutz
            </Link>
            <Link to="/nutzungsbedingungen" className="text-textMuted hover:text-primary transition-colors">
              Nutzungsbedingungen
            </Link>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-borderDark/30 text-center">
          <p className="text-[10px] text-textMuted/40 uppercase tracking-widest">
            Entwickelt für maximale Privatsphäre ohne externe Abhängigkeiten
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;